import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ztapbnlxpqzkjyjiahvm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp0YXBibmx4cHF6a2p5amlhaHZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI1NDEyOTcsImV4cCI6MjA0ODExNzI5N30.A7VlpG3DCeK63iQIgjbSYKfRM3p22vbtn8spJq4E6cg';
export const supabase = createClient(supabaseUrl, supabaseKey);
